// extracted by mini-css-extract-plugin
module.exports = {"page":"page__1iidI","page-inner":"page-inner__1hItp"};